import { DefineComponent } from 'vue';
import { FormPaths } from '@core/utils/forms-paths';

const formsPaths: FormPaths[] = [
    [
        import.meta.glob<DefineComponent>(
            '/vendor/kibokosrl/kiboko-backoffice-forms/resources/js/Components/Forms/**/*.vue',
        ),
        '/vendor/kibokosrl/kiboko-backoffice-forms/resources/js/Components/Forms/',
    ],
];

export default formsPaths;
